import * as React from 'react';

import { EAppsCounters, EResponseStatus } from '@enums';

import { IAppsByGenreStore } from '@stores';

import { counters, translations } from '@base/utils';

import { AppsCarousel, ContentPanel, EAppItemType } from '@components';

import { orderedGenres } from '../utils/constants';
import { getCompilationVisibility } from '../utils/getCompilationVisibility';

import * as s from './style/Panel.scss';

interface IPanel {
	store: IAppsByGenreStore;
}

export const AppsGenres = ({
	store,
}: IPanel) => {
	const onClickGenreAppsPageLink = (counter: EAppsCounters) => () => {
		counters.sendRB(counter);
	};
	return <>
		{orderedGenres.map(({ genre, counter, ref }) => {
			const compilation = store.getByGenre(genre);
			const isVisible = getCompilationVisibility(compilation);
			const onClick = () => onClickGenreAppsPageLink(counter);

			if (!isVisible) {
				return null;
			}

			return <ContentPanel
				key={genre}
				title={translations.appCatalog(genre)}
				onLinkClick={onClick}
				linkUrl={`/${genre}`}
			>
				<AppsCarousel
					className={s.carousel}
					apps={compilation?.data}
					responseStatus={compilation?.status || EResponseStatus.PENDING}
					type={EAppItemType.MEDIUM}
					urlRef={ref}
					hasTitle
					hasInstalls
				/>
			</ContentPanel>;
		})}
	</>;
};
